import React from "react";
import env from "../../../env/env.json";
import { optionsIndice } from "../../../utils/selectOptions";
import Select from "../../UI/Select";

const FormLocalDemande = ({
  formData,
  handleChange,
  inputFocus,
  handleTrimValue,
  ville,
}) => {
  const CP = env.CP;
  // const ville = env.ville;
  return (
    <>
      <p className="fw-bold">
        Adresse du local faisant objet de la demande du changement
        d'usage&nbsp;:
      </p>
      <div className="background--warning p-3">
        <div className="row pb-4">
          <div className="col-12 col-md-4 position-relative">
            <label htmlFor="LocAdrNum" className="form-label">
              Numéro de voie <span className="text-danger">(facultatif)</span>
              &nbsp;:
            </label>
            <input
              type="text"
              pattern="[0-9]+"
              className="form-control inputReg getLabel"
              name="LocAdrNum"
              id="LocAdrNum"
              maxLength={5}
              value={formData.LocAdrNum || ""}
              onChange={handleChange}
              onInput={inputFocus}
              onBlur={handleTrimValue}
              autoComplete="nope"
            />
            <div className="invalid-tooltip">
              Veuillez entrer un numéro valide
            </div>
          </div>
          <div className="col-12 col-md-3 mt-3 mt-md-0 position-relative">
            <Select
              selectClassName={"page-3-required"}
              name="LocAdrRepetition"
              value={formData.LocAdrRepetition}
              handleChange={handleChange}
              inputFocus={inputFocus}
              options={optionsIndice}
              label="Indice de répétition :"
            />
          </div>
          <div className="col-12 col-md-5 mt-3 mt-md-0 position-relative">
            <label htmlFor="LocAdrRue" className="form-label">
              Type et nom de voie&nbsp;:&nbsp;
              <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control page-3-required getLabel"
              name="LocAdrRue"
              id="LocAdrRue"
              maxLength={50}
              value={formData.LocAdrRue || ""}
              onChange={handleChange}
              onInput={inputFocus}
              onBlur={handleTrimValue}
              required
              autoComplete="nope"
            />
            <div className="invalid-tooltip">
              Veuillez remplir ce champs obligatoire
            </div>
          </div>
        </div>
        <div className="row pb-4">
          <div className="col-12 mt-3 mt-md-0 position-relative">
            <label htmlFor="LocAdrComp" className="form-label">
              Complément d'adresse{" "}
              <span className="text-danger">(facultatif)</span>&nbsp;:
            </label>
            <input
              type="text"
              className="form-control getLabel"
              name="LocAdrComp"
              id="LocAdrComp"
              maxLength={50}
              value={formData.LocAdrComp || ""}
              onInput={inputFocus}
              onChange={handleChange}
              onBlur={handleTrimValue}
              autoComplete="nope"
            />
          </div>
        </div>
        <div className="row pb-4">
          <div className="col-12 col-md-4 position-relative">
            <label htmlFor="LocAdrPorte" className="form-label">
              Porte / Appt <span className="text-danger">(facultatif)</span>
              &nbsp;:
            </label>
            <input
              type="text"
              className="form-control page-3-required getLabel"
              name="LocAdrPorte"
              id="LocAdrPorte"
              maxLength={5}
              value={formData.LocAdrPorte || ""}
              onChange={handleChange}
              onInput={inputFocus}
              onBlur={handleTrimValue}
              autoComplete="nope"
            />
            <div className="invalid-tooltip">
              Veuillez remplir ce champs obligatoire
            </div>
          </div>
          <div className="col-12 col-md-4 pt-3 pt-md-0">
            <label htmlFor="LocAdrEscalier" className="form-label">
              Escalier <span className="text-danger">(facultatif)</span>&nbsp;:
            </label>
            <input
              type="text"
              className="form-control getLabel"
              name="LocAdrEscalier"
              id="LocAdrEscalier"
              maxLength={10}
              value={formData.LocAdrEscalier || ""}
              onChange={handleChange}
              onBlur={handleTrimValue}
              autoComplete="nope"
            />
          </div>
          <div className="col-12 col-md-4 pt-3 pt-md-0">
            <label htmlFor="LocAdrBat" className="form-label">
              Bâtiment <span className="text-danger">(le cas échéant)</span>
              &nbsp;:
            </label>
            <input
              type="text"
              className="form-control getLabel"
              name="LocAdrBat"
              id="LocAdrBat"
              maxLength={30}
              value={formData.LocAdrBat || ""}
              onChange={handleChange}
              onBlur={handleTrimValue}
              autoComplete="nope"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-md-4 pt-3 pt-md-0 position-relative">
            <label htmlFor="LocAdrCP" className="form-label">
              Code postal&nbsp;:
            </label>
            <input
              type="text"
              className="form-control getLabel"
              name="LocAdrCP"
              id="LocAdrCP"
              value={(formData.LocAdrCP = CP)}
              disabled
            />
          </div>
          <div className="col-12 col-md-8 pt-3 pt-md-0 position-relative">
            <label htmlFor="ImmLocaliteAdr" className="form-label">
              Commune&nbsp;:
            </label>
            <input
              type="text"
              className="form-control getLabel"
              name="ImmLocaliteAdr"
              id="ImmLocaliteAdr"
              value={(formData.ImmLocaliteAdr = ville)}
              disabled
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default FormLocalDemande;
